import { LogLevel, Config, CommonEvents, ConfigEvents } from '@darwin/config';
export { CommonEvents, Config, ConfigEvents, LogLevel } from '@darwin/config';
import { InjectionToken, Injectable, Optional, Inject, NgModule, APP_INITIALIZER, SkipSelf } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/config.tokens.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const _CONFIG_SETTINGS = new InjectionToken('@ng-darwin/config settings');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/config-settings.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Service in charge of storing the needed properties to instantiate Config Class
 *
 * @ignore
 *
 */
class ConfigSettingsService {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.logEvent = {
            level: LogLevel.NONE
        };
        this.errorEvent = {};
        this.configLoadedEvent = {};
        if (settings) {
            this.logEvent = Object.assign(this.logEvent, settings.logEvent);
            this.errorEvent = Object.assign(this.errorEvent, settings.errorEvent);
            this.configLoadedEvent = Object.assign(this.configLoadedEvent, settings.configLoadedEvent);
        }
    }
}
ConfigSettingsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ConfigSettingsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [_CONFIG_SETTINGS,] }] }
];
if (false) {
    /** @type {?} */
    ConfigSettingsService.prototype.logEvent;
    /** @type {?} */
    ConfigSettingsService.prototype.errorEvent;
    /** @type {?} */
    ConfigSettingsService.prototype.configLoadedEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * When this service is injected in any component the service will have
 * the methods and properties to access to the project configuration.
 * Please follow this [link](../modules/_ng_darwin_config.html#configservice) for more information about this service.
 *
 * \@usageNotes
 * Sample ConfigService use
 *
 * ### Example. How to get the loaded config
 * ``` ts
 * const configService: ConfigService
 *
 * console.log(configService.config); // logs a json object
 * ```
 */
class ConfigService extends Config {
    /**
     * @param {?} css
     */
    constructor(css) {
        super(css.logEvent.level);
    }
}
ConfigService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ConfigService.ctorParameters = () => [
    { type: ConfigSettingsService }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/config.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@TODO
 *
 * @ignore
 * @param {?} configService -pending
 * @param {?} css config settings -- pending
 *
 * @return {?}
 */
function initFactory(configService, css) {
    /** @type {?} */
    const logHandler = css.logEvent.handler;
    /** @type {?} */
    const errorHandler = css.errorEvent.handler;
    /** @type {?} */
    const configLoadedHandler = css.configLoadedEvent.handler;
    // register handlers if there are any defined
    if (logHandler) {
        logHandler.unsubscribe = configService.on(CommonEvents.LOG, (/**
         * @param {...?} args
         * @return {?}
         */
        (...args) => {
            logHandler(...args);
        }));
    }
    if (errorHandler) {
        errorHandler.unsubscribe = configService.on(CommonEvents.ERROR, (/**
         * @param {...?} args
         * @return {?}
         */
        (...args) => {
            errorHandler(...args);
        }));
    }
    if (configLoadedHandler) {
        configLoadedHandler.unsubscribe = configService.on(ConfigEvents.CONFIG_LOADED, (/**
         * @param {...?} args
         * @return {?}
         */
        (...args) => {
            configLoadedHandler(...args);
            ((/** @type {?} */ (configLoadedHandler))).unsubscribe();
        }));
    }
    // load config props promise
    return (/**
     * @return {?}
     */
    () => configService
        .load()
        .catch((/**
     * @param {?} err
     * @return {?}
     */
    err => {
        if (console.error) {
            console.error(err);
        }
    })));
}
class ConfigModule {
    /**
     * @param {?} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('ConfigModule is already loaded. Import it isolated or through CoreModule, but in the AppModule only');
        }
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    static forRoot(settings) {
        return {
            ngModule: ConfigModule,
            providers: [
                {
                    provide: _CONFIG_SETTINGS,
                    useValue: settings
                }
            ]
        };
    }
}
ConfigModule.decorators = [
    { type: NgModule, args: [{
                providers: [
                    ConfigSettingsService,
                    ConfigService,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: initFactory,
                        deps: [ConfigService, ConfigSettingsService],
                        multi: true
                    }
                ]
            },] }
];
/** @nocollapse */
ConfigModule.ctorParameters = () => [
    { type: ConfigModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/stubs/config-stub.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const _CONFIG_JSON_STUB = new InjectionToken('@ng-darwin/config json stub');
/** @type {?} */
const configMock = {
    appKey: 'appKey_mock',
    appName: 'appName_mock',
    app: {}
}
/**
 * ConfigService Mock.
 * Please follow this [link](../modules/_ng_darwin_config.html#test-unitarios) for more info about unit testing.
 */
;
/**
 * ConfigService Mock.
 * Please follow this [link](../modules/_ng_darwin_config.html#test-unitarios) for more info about unit testing.
 */
class ConfigServiceStub {
    /**
     * @param {?} customConfigMock
     */
    constructor(customConfigMock) {
        this.config = customConfigMock || configMock;
    }
    /**
     * Config property
     * @return {?}
     */
    get config() { return this._config; }
    /**
     * @param {?} value
     * @return {?}
     */
    set config(value) { this._config = value; }
    /**
     * Returns a promise resolved
     * @return {?}
     */
    load() {
        return Promise.resolve(this.config);
    }
    /**
     * Returns a function that does nothing
     * @return {?}
     */
    on() {
        return (/**
         * @return {?}
         */
        () => { });
    }
}
ConfigServiceStub.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ConfigServiceStub.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [_CONFIG_JSON_STUB,] }] }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    ConfigServiceStub.prototype._config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/stubs/config-testing.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class for testing proposes:
 * - It provides a stub for ConfigService
 *
 * Please follow this [link](../modules/_ng_darwin_config.html#test-unitarios) for more info about unit testing.
 */
/**
 * ConfigTestingModule class for testing proposes
 */
class ConfigTestingModule {
    /**
     * @param {?} configMock
     * @return {?}
     */
    static forRoot(configMock) {
        return {
            ngModule: ConfigTestingModule,
            providers: [
                {
                    provide: _CONFIG_JSON_STUB,
                    useValue: configMock
                }
            ]
        };
    }
}
ConfigTestingModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    ConfigModule,
                ],
                providers: [
                    ConfigServiceStub,
                    { provide: ConfigService, useExisting: ConfigServiceStub }
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/version.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Version of NgDarwin.
 * The Darwin libraries for the Angular framework.
 * @type {?}
 */
const version = 'ng-darwin/8.5.0';

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ng-darwin-config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ConfigModule, ConfigService, ConfigTestingModule, version, initFactory as ɵa, ConfigSettingsService as ɵb, _CONFIG_SETTINGS as ɵc, _CONFIG_JSON_STUB as ɵd, ConfigServiceStub as ɵe };
//# sourceMappingURL=ng-darwin-config.js.map
